import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const CompetitionPerformanceReport = () => {

    const [stateList, setStateList] = useState<any[]>([]);
    const [districtList, setDistrictList] = useState<any[]>([]);
    const [cityList, setCityList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [competitionPerformanceList, setCompetitionPerformanceList] = useState<any[]>([]);
    const [competitionTypeList, setCompetitionTypeList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [coachList, setCoachList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [stateId, setStateId] = useState("");
    const [districtId, setDistrictId] = useState("");
    const [cityId, setCityId] = useState("");
    const [centerId, setCenterId] = useState("");
    const [competitionTypeId, setCompetitionTypeId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [coachId, setCoachId] = useState("");
    const [sportId, setSportId] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [showTable, setShowTable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function fetchInitial() {
            setIsLoading(true);
            const compResponse = await func.competitionType(null);
            setCompetitionTypeList(Array.isArray(compResponse) ? compResponse : [])
            const statesResponse = await func.listGeoCenters();
            setCenterList(Array.isArray(statesResponse) ? statesResponse : [])
            setIsLoading(false);
        }
        fetchInitial();
    }, [])


    const filteredData = competitionPerformanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.Athlet}</span>
    };

    const competitionNameRender = (rowData) => {
        return <span>{rowData.competitionName}</span>
    };

    const sportNameRender = (rowData) => {
        return <span>{rowData.sportName}</span>
    };

    const athletePerformanceStatisticRender = (rowData) => {
        return <span>{rowData.athletePerformanceStatistic}</span>
    };

    const athleteRankRender = (rowData) => {
        return <span>{rowData.athleteRank}</span>
    };

    const remarksRender = (rowData) => {
        return <span>{rowData.remarks}</span>
    };

    function competitionPerformanceReport() {
        const prfmRpt = api.CompetitionPerformanceReport + '/' + competitionTypeId + '/' + sportId + '/' + athleteId + '/' + coachId;
        fetch(prfmRpt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setCompetitionPerformanceList(result.data)
                    setShowTable(true)
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                    setShowTable(false)
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Competition Performance Report</h4>
                                </div>
                                <hr className="mb-10" />
                            </div>
                            <div className="row">
                                {/* <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">State</label>
                                        <Select
                                            value={stateList.find(state => state.geographyId === stateId) ? {
                                                value: stateId,
                                                label: stateList.find(state => state.geographyId === stateId).geographyName
                                            } : null}
                                            onChange={async (e) => {
                                                setStateId(e.value);
                                                const stateResponse = await func.listGeoDistrictByStateId(e?.value);
                                                setDistrictList(Array.isArray(stateResponse) ? stateResponse : [])
                                            }}
                                            required
                                            placeholder="Select State"
                                            options={stateList.map(state => ({
                                                value: state.geographyId,
                                                label: state.geographyName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">District</label>
                                        <Select
                                            value={districtList.find(district => district.geoDistrictsId === districtId) ? {
                                                value: districtId,
                                                label: districtList.find(district => district.geoDistrictsId === districtId).geoDistrictsName
                                            } : null}
                                            onChange={async (e) => {
                                                setDistrictId(e.value);
                                                const cityResponse = await func.listGeoCityByDistrictId(e?.value);
                                                setCityList(Array.isArray(cityResponse) ? cityResponse : [])
                                            }}
                                            required
                                            placeholder="Select District"
                                            options={districtList.map(district => ({
                                                value: district.geoDistrictsId,
                                                label: district.geoDistrictsName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">City</label>
                                        <Select
                                            value={cityList.find(city => city.geoCityId === cityId) ? {
                                                value: cityId,
                                                label: cityList.find(city => city.geoCityId === cityId).geoCityName
                                            } : null}
                                            onChange={async (e) => {
                                                setCityId(e.value);
                                                const cntrResponse = await func.listGeoCentersByCityId(e?.value);
                                                setCenterList(Array.isArray(cntrResponse) ? cntrResponse : [])
                                            }}
                                            required
                                            placeholder="Select City"
                                            options={cityList.map(city => ({
                                                value: city.geoCityId,
                                                label: city.geoCityName
                                            }))}>
                                        </Select>
                                    </div>
                                </div> */}
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Center</label>
                                        <Select
                                            value={centerList.find(center => center.geoCenterId === centerId) ? {
                                                value: centerId,
                                                label: centerList.find(center => center.geoCenterId === centerId).geoCenterName
                                            } : null}
                                            onChange={async (e) => {
                                                setCenterId(e.value);
                                                const cochResponse = await func.coachByCenter(e?.value);
                                                setCoachList(Array.isArray(cochResponse) ? cochResponse : [])
                                            }}
                                            required
                                            placeholder="Select Center"
                                            options={centerList.map(center => ({
                                                value: center.geoCenterId,
                                                label: center.geoCenterName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Competition Type</label>
                                        <Select
                                            value={competitionTypeList.find(compTyp => compTyp.competitionTypeId === competitionTypeId) ? {
                                                value: competitionTypeId,
                                                label: competitionTypeList.find(compTyp => compTyp.competitionTypeId === competitionTypeId).competitionTypeName
                                            } : null}
                                            onChange={async (e) => {
                                                setCompetitionTypeId(e.value);
                                                const athltResponse = await func.listActiveAthletes();
                                                setAthleteList(Array.isArray(athltResponse) ? athltResponse : [])
                                            }}
                                            required
                                            placeholder="Select Competition Type"
                                            options={competitionTypeList.map(compTyp => ({
                                                value: compTyp.competitionTypeId,
                                                label: compTyp.competitionTypeName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Coach</label>
                                        <Select
                                            value={coachList.find(coch => coch.userId === coachId) ? {
                                                value: coachId,
                                                label: coachList.find(coch => coch.userId === coachId).coachName
                                            } : null}
                                            onChange={async (e) => {
                                                setCoachId(e.value);
                                                const sportResponse = await func.sportByCoachId(e?.value);
                                                setSportList(Array.isArray(sportResponse) ? sportResponse : [])
                                            }}
                                            required
                                            placeholder="Select Coach"
                                            options={coachList.map(coch => ({
                                                value: coch.userId,
                                                label: coch.coachName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sport</label>
                                        <Select
                                            value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                                value: sportId,
                                                label: sportList.find(sprt => sprt.sportId === sportId).sportsName
                                            } : null}
                                            onChange={async (e) => {
                                                setSportId(e.value);
                                            }}
                                            required
                                            placeholder="Select Sport"
                                            options={sportList.map(sprt => ({
                                                value: sprt.sportId,
                                                label: sprt.sportsName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Athlete</label>
                                        <Select
                                            value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                value: athleteId,
                                                label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                            } : null}
                                            onChange={async (e) => {
                                                setAthleteId(e.value);
                                            }}
                                            required
                                            placeholder="Select Athlete"
                                            options={athleteList.map(athlt => ({
                                                value: athlt.userId,
                                                label: athlt.athleteName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row justify-content-end">
                                    <div className="col-lg-2 col-sm-12 mb-2">
                                        <Button
                                            type="button"
                                            variant="secondary"
                                            onClick={competitionPerformanceReport}
                                            className="w-100"
                                        >
                                            Submit
                                        </Button>
                                    </div>

                                    {/* <div className="col-lg-2 col-sm-12 mb-2">
                                        <Button
                                            type="button"
                                            variant="secondary"
                                            // onClick={exportToExcel} // ✅ Uncomment when function is ready
                                            className="w-100"
                                        >
                                            Export to Excel
                                        </Button>
                                    </div> */}
                                </div>
                                <hr className="mb-10" />
                                {showTable && (
                                    <div className="tab-content">
                                        <div className="col-lg-12 col-sm-12 mb-10 text-end dataTables_filter">
                                            <label>
                                                <input
                                                    type="text"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    style={{ height: "40px" }}
                                                    placeholder="Search"
                                                    className="form-control"
                                                />
                                            </label>
                                        </div>
                                        <div
                                            className="tab-pane fade show active"
                                            id="nav-Recent"
                                            role="tabpanel"
                                            aria-labelledby="nav-Recent-tab"
                                            tabIndex={0}
                                        >
                                            <div className="table-responsive table-datatble">
                                                <DataTable
                                                    className="table datatable"
                                                    value={filteredData}
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                    pageLinkSize={3}
                                                >
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="slNo"
                                                        body={slNoRender}
                                                        header="Sl &nbsp; No"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="athlet"
                                                        header="Athlete Name"
                                                        body={athleteNameRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="competitionName"
                                                        header="Competition Name"
                                                        body={competitionNameRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="sportName"
                                                        header="Sport Name"
                                                        body={sportNameRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="athletePerformanceStatistic"
                                                        header="Athlete Performance Statistic"
                                                        body={athletePerformanceStatisticRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="athleteRank"
                                                        header="Athlete Rank"
                                                        body={athleteRankRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="remarks"
                                                        header="Remarks"
                                                        body={remarksRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompetitionPerformanceReport;